
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support-your-team",
      function () {
        return require("private-next-pages/support-your-team.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/support-your-team"])
      });
    }
  